import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { sectionsAPI } from '../lib/api';

// Los apartados los escribe el admin (pestaña Contenido). Se piden una vez
// por carga y se comparten entre portada y fichas.
let cache = null;
const loadSections = () => {
    if (!cache) {
        cache = sectionsAPI.getAll().then(r => r.data || []).catch(() => {
            cache = null;
            return [];
        });
    }
    return cache;
};

const TONES = {
    kraft: { background: 'var(--kraft)', color: 'var(--ink)', border: 'var(--kraft-deep)' },
    ink: { background: 'var(--ink)', color: 'var(--paper)', border: 'var(--ink)' },
    paper: { background: 'var(--paper-2)', color: 'var(--ink)', border: 'var(--line)' },
};

export function filterSections(sections, placement, productId) {
    return sections.filter(s => {
        if (placement === 'home') return s.placement === 'home' || s.placement === 'both';
        if (s.placement !== 'product' && s.placement !== 'both') return false;
        return !s.product_id || s.product_id === productId;
    });
}

function SectionCta({ section }) {
    if (!section.cta_label || !section.cta_url) return null;
    const cls = 'inline-flex items-center gap-2 mt-4 font-bold text-sm uppercase tracking-wider underline underline-offset-4';
    const content = <>{section.cta_label} <ArrowRight className="w-4 h-4" /></>;
    return section.cta_url.startsWith('/')
        ? <Link to={section.cta_url} className={cls}>{content}</Link>
        : <a href={section.cta_url} target="_blank" rel="noopener noreferrer" className={cls}>{content}</a>;
}

export default function SiteSections({ placement, productId, className = '' }) {
    const [sections, setSections] = useState([]);

    useEffect(() => {
        let alive = true;
        loadSections().then(all => { if (alive) setSections(filterSections(all, placement, productId)); });
        return () => { alive = false; };
    }, [placement, productId]);

    if (!sections.length) return null;

    return (
        <div className={`grid gap-4 ${className}`} data-testid={`site-sections-${placement}`}>
            {sections.map(s => {
                const tone = TONES[s.tone] || TONES.kraft;
                return (
                    <aside
                        key={s.id}
                        className="rounded-sm border-2 px-6 py-5 md:px-8 md:py-6"
                        style={{ backgroundColor: tone.background, color: tone.color, borderColor: tone.border }}
                        data-testid="site-section"
                    >
                        {s.eyebrow && (
                            <p className="font-mono text-[10px] uppercase tracking-[0.18em] mb-2 opacity-80">{s.eyebrow}</p>
                        )}
                        <h2 className="font-heading text-2xl md:text-3xl font-black text-balance">{s.title}</h2>
                        {s.body && <p className="mt-2 text-[15px] leading-relaxed text-pretty whitespace-pre-line">{s.body}</p>}
                        <SectionCta section={s} />
                    </aside>
                );
            })}
        </div>
    );
}
